export function cardId(id) {
  return `data-card-${id}`;
}
